import { Injectable, signal } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@sbd-doug-frontend/app/environments/environment';

export type ProcessMissingScheduleUnableToProcessItem = {
  order_number: string;
  error: string;
};

export type ProcessMissingScheduleResponse = {
  success: boolean;
  message: string;
  error: string | null;
  data: {
    unable_to_process: ProcessMissingScheduleUnableToProcessItem[];
    scheduled: Array<{ order_number: string }>;
  } | null;
};

export type ProcessMissingUiFieldsResponse = {
  success: boolean;
  message: string;
  error: string | null;
  data: {
    fields: {
      quote_request: Record<string, string>;
      quote_request_bond: Record<string, string>;
    };
  } | null;
};

@Injectable({
  providedIn: 'root',
})
export class ProcessMissingService {
  public isLoading = signal(false);

  constructor(private _httpClient: HttpClient) {}

  schedule(payload: { order_numbers: string[]; configuration: unknown }): Observable<ProcessMissingScheduleResponse> {
    this.isLoading.set(true);

    const url = `${environment.apiBaseUrl}/${environment.apiPrefix}/policy/renewals/process-missing/schedule`;
    return this._httpClient.post<ProcessMissingScheduleResponse>(url, payload).pipe(finalize(() => this.isLoading.set(false)));
  }

  getUiFields(): Observable<ProcessMissingUiFieldsResponse> {
    const url = `${environment.apiBaseUrl}/${environment.apiPrefix}/policy/renewals/process-missing/ui-fields`;
    return this._httpClient.get<ProcessMissingUiFieldsResponse>(url);
  }
}
